/**
 * @module VerifySharedConstants
 * @description Phase 10 extraction of constants shared by Scripted, Web, WiFi, and VoIP verify flows.
 * Composed through VerifyConstants for backward-compatible imports.
 */
export const QUICK_TEST_TYPE = {
    ADVANCED: 'advanced',
    URL: 'url',
    EXISTING: 'existing',
    VOIP_PULSE_TO_PULSE: 'VoipPulse',
    VOIP_PULSE_TO_PHONE: 'VoipPhone',
    VOIP_DIAL: 'VoipDial',
    OTHER: 'other',
};

/**
 * Agent-level result status codes (from quickTests.constants.js QUICK_TEST_AGENT_RESULTS_STATUS).
 * These are single-letter codes on each agentResult entry.
 */
export const AGENT_RESULT_STATUS = {
    INITIALIZING: 'I',
    SETTING_UP: 'S',
    QUEUED: 'Q',
    RUNNING: 'R',
    TEARING_DOWN: 'T',
    COMPLETE: 'C',
    ERROR: 'E',
    CANCELED: 'X',
};

/**
 * Native test type name constants (from common.constants.js NATIVE_TEST).
 * Used to route to the correct strategy.
 */
export const NATIVE_TEST = {
    Web: 'Web',
    VoipPulseToPulse: 'VoipPulse',
    VoipPulseToPhone: 'VoipPhone',
    VoipDial: 'VoipDial',
};

/**
 * Quick test overall status values (from quickTests.constants.js QUICK_TEST_STATUS).
 * These are the top-level status of the entire quick test record.
 */
export const QUICK_TEST_STATUS = {
    INITIALIZING: 'Initializing',
    SETTING_UP: 'Setting Up',
    RUNNING: 'Running',
    TEARING_DOWN: 'Tearing Down',
    COMPLETE: 'Complete',
    ERROR: 'Error',
    CANCELED: 'Canceled',
};

/**
 * All quick test status values as an array — used as the query filter
 * when polling for verify results. Mirrors portal/ui's QuickTestsService.getQuickTestById().
 */
export const ALL_QUICKTEST_STATUSES = Object.values(QUICK_TEST_STATUS);

/** Agent status value for "enabled/running" (from agents.constants.js ENUM_LOOKUP.statuses.enable) */
export const AGENT_STATUS_RUNNING = 'Running';

/** Maximum number of agents to include in a verify test */
export const MAX_VERIFY_AGENTS = 10;

/** WiFi Connect test types (wifiConnectTest === true) */
export const WIFI_CONNECT_TYPES = new Set(['wifiConnect', 'wiFiMultiBssidConnection', 'wifiConnectMultiTest']);

/** WiFi test type names that force adapterType = 'wireless' in payload */
export const WIFI_WIRELESS_ADAPTER_TYPES = new Set(['wifi', 'wifiConnect']);
